import { BaseComponent, SbBlokData } from '@cinch-nx/data-storyblok'
import styles from './grid-rows.module.css'
import { StoryblokRenderer } from '@cinch-nx/storyblok-utils'
import { FlexboxTwoColumns } from '@cinch-nx/shared-ui'
import { atomStoryblokComponents } from '../../data-maps/atom-storyblok-components-map'
interface Row extends BaseComponent {
  columns: SbBlokData[]
  reverseColumnOrderForMobile: boolean
}

interface GridRowsProps extends BaseComponent {
  component: 'GridRows'
  rows: Row[]
}

export const GridRows = ({ rows }: GridRowsProps) => {
  const grid = {
    rows: rows.map((row) => ({
      columns: row.columns.map((column) => (
        <StoryblokRenderer
          block={column}
          components={atomStoryblokComponents}
        />
      )),
      reverseColumnOrderForMobile: row.reverseColumnOrderForMobile,
    })),
  }

  return (
    <FlexboxTwoColumns
      rows={grid.rows}
      classNamings={{
        container: styles.container,
        row: styles.row,
        column: styles.column,
      }}
    />
  )
}
